import { SECTION1 } from './section1';
import { SECTION10 } from './section10';
import { SECTION11 } from './section11';
import { SECTION12 } from './section12';
import { SECTION13 } from './section13';
import { SECTION14 } from './section14';
import { SECTION15 } from './section15';
import { SECTION16 } from './section16';
import { SECTION17 } from './section17';
import { SECTION18 } from './section18';
import { SECTION19 } from './section19';
import { SECTION2 } from './section2';
import { SECTION20 } from './section20';
import { SECTION21 } from './section21';
import { SECTION22 } from './section22';
import { SECTION23 } from './section23';
import { SECTION24 } from './section24';
import { SECTION25 } from './section25';
import { SECTION26 } from './section26';
import { SECTION27 } from './section27';
import { SECTION28 } from './section28';
import { SECTION29 } from './section29';
import { SECTION3 } from './section3';
import { SECTION30 } from './section30';
import { SECTION31 } from './section31';
import { SECTION32 } from './section32';
import { SECTION33 } from './section33';
import { SECTION34 } from './section34';
import { SECTION35 } from './section35';
import { SECTION36 } from './section36';
import { SECTION37 } from './section37';
import { SECTION38 } from './section38';
import { SECTION39 } from './section39';
import { SECTION4 } from './section4';
import { SECTION5 } from './section5';
import { SECTION6 } from './section6';
import { SECTION7 } from './section7';
import { SECTION8 } from './section8';
import { SECTION8A } from './section8A';
import { SECTION9 } from './section9';

const Copy = {
  SECTION1,
  SECTION2,
  SECTION3,
  SECTION4,
  SECTION5,
  SECTION6,
  SECTION7,
  SECTION8,
  SECTION8A,
  SECTION9,
  SECTION10,
  SECTION11,
  SECTION12,
  SECTION13,
  SECTION14,
  SECTION15,
  SECTION16,
  SECTION17,
  SECTION18,
  SECTION19,
  SECTION20,
  SECTION21,
  SECTION22,
  SECTION23,
  SECTION24,
  SECTION25,
  SECTION26,
  SECTION27,
  SECTION28,
  SECTION29,
  SECTION30,
  SECTION31,
  SECTION32,
  SECTION33,
  SECTION34,
  SECTION35,
  SECTION36,
  SECTION37,
  SECTION38,
  SECTION39,
};

export default Copy;
